import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Table from 'react-virtualized/dist/commonjs/Table/Table';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import 'react-virtualized/styles.css';

function TableVirtualized({
  children,
  data,
  minusHeight,
  striped,
  hover,
  customHeight,
  ...rest
}) {
  const tableRef = createRef();

  const pcustomHeight = (autoHeight) => {
    return customHeight(autoHeight);
  };

  return (
    <AutoSizer>
      {({ width, height }) => {
        return (
          <Table
            ref={tableRef}
            rowClassName={`border-b text-sm ${
              hover ? 'hover:bg-light-blue-color' : ''
            }`}
            headerHeight={50}
            rowHeight={50}
            height={customHeight ? pcustomHeight(height) : height}
            rowGetter={({ index }) => {
              return data[index];
            }}
            rowCount={data.length}
            width={width}
            rowStyle={({ index }) => {
              if (index % 2 === 0 && striped) {
                return {
                  backgroundColor: 'var(--light-blue-color)',
                };
              }
              return {};
            }}
            {...rest}
          >
            {children}
          </Table>
        );
      }}
    </AutoSizer>
  );
}

TableVirtualized.defaultProps = {
  children: null,
  data: [],
  minusHeight: 0,
  striped: true,
  hover: true,
  customHeight: null,
};

TableVirtualized.propTypes = {
  children: PropTypes.node,
  data: PropTypes.instanceOf(Array),
  minusHeight: PropTypes.number,
  striped: PropTypes.bool,
  hover: PropTypes.bool,
  customHeight: PropTypes.instanceOf(Function),
};

TableVirtualized.Column = Column;

export default TableVirtualized;
